import { render } from "./HomeContact.vue?vue&type=template&id=4b651e91"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import "./HomeContact.vue?vue&type=style&index=0&id=4b651e91&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__